import { createBrowserHistory } from "history";

let history = null;
if (process.env.REACT_APP_IS_SSR !== "true") {
  history = createBrowserHistory();
}
export default history;
